import GameState from "slotworks/model/game-state";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";
import { Exit } from "slotworks/state-machine/data/exit";
import Decision from "slotworks/state-machine/decisions/decision";

export default class FreespinsRetriggered extends Decision {
    public evaluate() {
        let record = GameState.getCurrentGame().getCurrentRecord();

        if (!(record instanceof FreespinRecord) && record.lastChild) {
            record = record.parent;
        }

        return record instanceof FreespinRecord && record.getFreespinsWon() > 0 ? Exit.True : Exit.False;
    }
}
